/**
 * chatHeight is which of its two heights the chat sheet takes.
 *
 * An empty conversation opens compact — the header, the line and the input —
 * so the book it is about stays readable above it. Anything to read in the
 * sheet makes it full: turns already asked, a question on its way, or a
 * character card. Once full it stays full until closed (`grown`): a sheet that
 * shrank again on "New chat" would move the input under the thumb.
 */
export function chatHeight(state: {
  turns: number;
  pending: boolean;
  showingCard: boolean;
  grown: boolean;
}): "compact" | "full" {
  return state.grown || state.turns > 0 || state.pending || state.showingCard ? "full" : "compact";
}
